<template>
  <div class="user-list">
    <h1 class="title">用户中心</h1>
    <table>
      <thead>
        <tr>
          <th>用户 ID</th>
          <th>活动 ID</th>
          <th>参与活动</th>
          <th>参与时间</th>
          <th>中奖结果</th>
          <th>操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(userActivity, index) in userActivities" :key="index">
          <td>{{ userActivity.userId }}</td>
          <td>{{ userActivity.activityId }}</td>
          <td>{{ userActivity.activityName }}</td>
          <td>{{ userActivity.participationTime }}</td>
          <td>
             {{ userActivity.prizeResult }}
              <el-link v-if="userActivity.prizeResult === '已中奖'" @click="detail(id)">
                <i class="el-icon-view el-icon--right"></i> 
              </el-link>
          </td>
          <td>
            <el-button type="text" @click="open">
                <i class="el-icon-edit"></i>
            </el-button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'User',
  data() {
    return {
      userActivities: [
        { userId: 1, activityId: 1, activityName: '夏季促销', participationTime: '2024-03-01T12:00:00', prizeResult: '未中奖' },
        { userId: 2, activityId: 2, activityName: '会员日优惠', participationTime: '2024-04-01T10:30:00', prizeResult: '已中奖' },
        { userId: 3, activityId: 3, activityName: '新品发布', participationTime: '2024-04-10T14:15:00', prizeResult: '未中奖' },
        // 更多用户数据...
      ]
    };
  },
  methods: {
    open() {
        this.$alert('开发中 ...', '编辑', {
          confirmButtonText: '确定',
          callback: () => {
            this.$message({
              type: 'info',
              message: '开发中'
            });
          }
        });
    },
    detail(id) {
        this.$alert('中奖结果：手机', '详情', {
          confirmButtonText: '确定',
        });
      }
  }
};
</script>

<style scoped>
.user-list {
  max-width: 50vx;
  margin: left;
}

.title {
  text-align: center;   
  color: #c0dcfb;
  font-size: 2em;
  margin-bottom: 20px;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th, td {
  padding: 10px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

th {
  background-color: #f2f2f2;
}

tr:hover {
  background-color: #f5f5f5;
}
</style>